/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "components/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Terms() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/portaal",
          label: "portaal",
          color: "info",
        }}
        sticky
      />

      <MKBox component="section" pt={20} pb={12}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={10}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="dark"
                  borderRadius="lg"
                  coloredShadow="dark"
                  p={3}
                  mt={-3}
                  mx={2}
                >
                  <MKTypography variant="h3" color="white">
                    Algemene Voorwaarden
                  </MKTypography>
                </MKBox>

                <MKBox pb={6} px={6}>
                  {/* 1. Wie wij zijn */}
                  <MKTypography variant="h4" mt={6} mb={3}>
                    1. Wie wij zijn
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    <strong>Willy Woef</strong> (&quot;wij&quot;, &quot;ons&quot;) exploiteert de
                    Willy Woef website en applicatie (de &quot;Dienst&quot;). Ingeschreven bij de
                    Kamer van Koophandel (KvK):
                    <strong> 22052216</strong>. E‑mail: <strong>info@willy-woef.nl</strong>.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 2. Wat wij aanbieden */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    2. Wat wij aanbieden
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    Wij leveren een online interface waarmee geregistreerde gebruikers met een
                    AI‑assistent kunnen chatten (aangestuurd door een externe leverancier) en
                    toegang krijgen tot gerelateerde tools (samen de &quot;Diensten&quot;). Wij
                    kunnen de Diensten in de tijd updaten of verbeteren.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 3. Rekeningen */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    3. Rekeningen
                  </MKTypography>
                  <ul style={{ paddingLeft: "1.2rem", marginTop: 0 }}>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        U verstrekt correcte gegevens en houdt uw inloggegevens vertrouwelijk.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        U bent verantwoordelijk voor alle activiteiten onder uw account.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        Meld onbevoegd gebruik direct aan ons.
                      </MKTypography>
                    </li>
                  </ul>

                  <Divider sx={{ my: 4 }} />

                  {/* 4. Toegestaan gebruik */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    4. Toegestaan gebruik
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={2}>
                    U gaat ermee akkoord om niet:
                  </MKTypography>
                  <ul style={{ paddingLeft: "1.2rem", marginTop: 0 }}>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        de wet te overtreden of rechten van derden te schenden (incl. IE‑rechten en
                        privacy).
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        illegale, schadelijke, discriminerende gegevens te uploaden of
                        persoonsgegevens te delen zonder rechtmatige grondslag.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        de Dienst te reverse‑engineeren, aan te vallen of te overbelasten.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        outputs te gebruiken om malware, spam, misleiding of ander hoog‑risico
                        content te maken/verspreiden.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        gebruikslimieten of toegangscontroles te omzeilen.
                      </MKTypography>
                    </li>
                  </ul>

                  <Divider sx={{ my: 4 }} />

                  {/* 5. Gebruikerscontent en AI‑outputs */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    5. Gebruikerscontent en AI‑outputs
                  </MKTypography>
                  <ul style={{ paddingLeft: "1.2rem", marginTop: 0 }}>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        <strong>Uw input</strong> (prompts, bestanden) blijft <strong>van u</strong>
                        . U verleent ons een niet‑exclusieve licentie om deze te hosten, verwerken
                        en weer te geven <strong>alleen</strong> om de Dienst te leveren.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        <strong>AI‑outputs</strong> worden aan u geleverd binnen toepasselijk recht.
                        Wij claimen geen eigendom op uw outputs. U bent verantwoordelijk voor uw
                        gebruik en controleert juistheid/geschiktheid.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        Dien <strong>geen</strong> bijzondere categorieën persoonsgegevens in,
                        tenzij wij dit expliciet vragen en u een geldige grondslag heeft.
                      </MKTypography>
                    </li>
                  </ul>

                  <Divider sx={{ my: 4 }} />

                  {/* 6. Diensten van derden */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    6. Diensten van derden
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    De Dienst integreert met een AI‑provider (momenteel <strong>OpenAI</strong>) en
                    mogelijk andere infrastructuurleveranciers. Gebruik van die diensten valt onder
                    hun voorwaarden waar van toepassing. Wij zijn niet verantwoordelijk voor
                    diensten van derden die wij niet controleren.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 7. Geen professioneel advies */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    7. Geen professioneel advies
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    AI‑outputs kunnen onjuist, onvolledig of verouderd zijn. Ze zijn
                    <strong> uitsluitend informatief</strong> en geen professioneel advies (bijv.
                    juridisch, medisch, financieel). Verifieer outputs voordat u daarop vertrouwt.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 8. Tarieven & betaling */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    8. Tarieven &amp; betaling
                  </MKTypography>
                  <ul style={{ paddingLeft: "1.2rem", marginTop: 0 }}>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        Prijzen: Zie onze tariefpagina voor actuele prijzen. BTW wordt berekend
                        conform Nederlandse wetgeving.
                      </MKTypography>
                    </li>
                    <li>
                      <MKTypography variant="body2" color="text" mb={1}>
                        Facturatiecyclus: Maandelijks vooruitbetaald of <em>per gesprek</em>
                        vooruitbetaald. Restituties conform ons restitutiebeleid.
                      </MKTypography>
                    </li>
                  </ul>

                  <Divider sx={{ my: 4 }} />

                  {/* 9. Duur en beëindiging */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    9. Duur en beëindiging
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    U kunt de Dienst op elk moment stopzetten. Wij kunnen uw account opschorten of
                    beëindigen bij een materiële schending van deze Voorwaarden of indien nodig
                    omwille van veiligheid, wetgeving of bedrijfsvoering. Na beëindiging kunnen wij
                    uw content verwijderen of anonimiseren, met inachtneming van wettelijke
                    bewaarplichten.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 10. Garanties & vrijwaringen */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    10. Garanties &amp; vrijwaringen
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    De Dienst wordt geleverd <strong>zoals hij is</strong> en{" "}
                    <strong>zoals beschikbaar</strong>. Voor zover wettelijk toegestaan wijzen wij
                    alle garanties af (incl. impliciete garanties van verkoopbaarheid, geschiktheid
                    voor een bepaald doel en niet‑inbreuk).
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 11. Aansprakelijkheid */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    11. Aansprakelijkheid
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    Voor zover toegestaan door Nederlands recht is onze totale aansprakelijkheid
                    voor schade voortvloeiend uit of in verband met de Dienst beperkt tot het
                    hoogste van
                    <strong> (a) € 1.000</strong> of{" "}
                    <strong>(b) de door u betaalde vergoedingen in de laatste 12 maanden</strong>.
                    Wij beperken aansprakelijkheid niet voor overlijden of persoonlijk letsel door
                    nalatigheid, of voor opzet/grove schuld. Bent u consument, dan blijven uw
                    dwingendrechtelijke rechten onverlet.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 12. Wijzigingen */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    12. Wijzigingen
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    Wij kunnen deze Voorwaarden wijzigen. Bij materiële wijzigingen geven wij
                    redelijke kennisgeving per e‑mail of in de app. Doorgaan met gebruik na de
                    ingangsdatum betekent dat u de nieuwe Voorwaarden accepteert.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 13. Toepasselijk recht en geschillen */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    13. Toepasselijk recht en geschillen
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    Nederlands recht is van toepassing. De rechtbank te Amsterdam is bij uitsluiting
                    bevoegd. Bent u EU‑consument, dan kunt u ook procederen bij uw lokale rechter.
                  </MKTypography>

                  <Divider sx={{ my: 4 }} />

                  {/* 14. Contact */}
                  <MKTypography variant="h4" mt={4} mb={3}>
                    14. Contact opnemen
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={3}>
                    Vragen over deze Voorwaarden: <strong>info@willy-woef.nl</strong>.
                  </MKTypography>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Terms;
